export function buildURL(endpoint, pathParams = [], queryParams = {}) {
    const url = [endpoint, ...pathParams].join('/')
    const query = new URLSearchParams(queryParams).toString()
    return query ? `${url}?${query}` : url
}
